import { FormControl, ValidatorFn, Validators } from "@angular/forms";
import { Flight } from "../../../../models/flight.model";
import { amount, flag, text } from "../../../form/controls";
import { FlightEditLookups } from "../../../form/flight-edit-lookups";

function flightTypeControl(flight: Flight, lookups: FlightEditLookups) {
    const groundRun = lookups.isGroundRun(flight);
    const notConvertible: ValidatorFn = (control) => (lookups.groundRunTypeId !== null && control.value === lookups.groundRunTypeId ? { groundRunConversion: true } : null);
    return new FormControl<number | null>(
        { value: flight.flightTypeId ?? lookups.flightTypeIdOf(flight.flightType), disabled: groundRun },
        groundRun ? [] : [Validators.required, notConvertible],
    );
}

export function flightControls(flight: Flight, lookups: FlightEditLookups) {
    return {
        flightTypeId: flightTypeControl(flight, lookups),
        // Never changed from the dialog.
        isHotRefuelFlight: new FormControl<boolean>({ value: flight.isHotRefuelFlight, disabled: true }, { nonNullable: true }),
        isPositioning: flag(flight.isPositioning),
        vemd: text(flight.vemd),
        flightSpecifications: new FormControl<number[]>([...flight.flightSpecificationIds], { nonNullable: true }),
        flightOperations: new FormControl<number[]>([...flight.flightOperationIds], { nonNullable: true }),
        flightTypeNotes: new FormControl<number[]>([...flight.flightTypeNoteIds], { nonNullable: true }),
        landings: amount(flight.landings),
        // A flight cycles at least once; a ground run may not.
        cycles: new FormControl<number | null>(flight.cycles, lookups.isGroundRun(flight) ? [Validators.min(0)] : [Validators.required, Validators.min(1)]),
    };
}
